import { AriaLabelingProps, DOMProps } from '@react-types/shared'
import { forwardRef } from 'react'

export interface FactoryPayload {
  props: Record<string, any>
  ref?: any
}

export type DataProps = {
  [key: `data-${string}`]: string
}

export type Factory<Payload extends FactoryPayload> = {
  props: Payload['props'] & DOMProps & AriaLabelingProps & DataProps
  ref: Payload['ref']
}

export type BlazeComponent<Payload extends FactoryPayload> = React.ForwardRefExoticComponent<
  Payload['props'] & React.RefAttributes<Payload['ref']>
>

export function factory<Payload extends FactoryPayload>(
  ui: React.ForwardRefRenderFunction<Payload['ref'], Payload['props']>,
) {
  const Component = forwardRef(ui) as BlazeComponent<Payload>

  return Component as BlazeComponent<Payload>
}
